<template>
	<div>
		<buttonlist
			@search="search"
			@reflash="reflash"
			@exps="exps"
			ref="SetBtn"
		></buttonlist>
		<el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="order_No" :label="$t('getapi[463]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="row_number" :label="$t('getapi[1425]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Relation_PO_Code" :label="$t('getapi[1710]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="VenderName" :label="$t('getapi[1197]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Pur_Order_Line" :label="$t('getapi[1758]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Requisition_No" :label="$t('getapi[1838]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="delive_order_No" :label="$t('getapi[1744]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="receive_person" :label="$t('getapi[1745]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="receive_Time" :label="$t('getapi[1839]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[4470]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_Time" :label="$t('getapi[1840]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="batch_No" :label="$t('getapi[1763]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="sequence_No" :label="$t('getapi[1764]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="check_person" :label="$t('getapi[1770]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="check_date" :label="$t('getapi[1841]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="" :label="$t('getapi[1842]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="specification" :label="$t('getapi[125]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="STUFF_MANUF_NAME" :label="$t('getapi[192]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Line_status" :label="$t('getapi[552]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="order_qty" :label="$t('getapi[1843]')" align="right">
				<template slot-scope="scope">
					{{scope.row.order_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="Pur_measureunit" :label="$t('getapi[1166]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="actual_qty" :label="$t('getapi[1844]')" align="right">
				<template slot-scope="scope">
					{{scope.row.actual_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="wait_check_qty" :label="$t('getapi[1845]')" align="right">
				<template slot-scope="scope">
					{{scope.row.wait_check_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="qualify_qty" :label="$t('getapi[1846]')" align="right">
				<template slot-scope="scope">
					{{scope.row.qualify_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="disqualify_qty" :label="$t('getapi[1847]')" align="right">
				<template slot-scope="scope">
					{{scope.row.disqualify_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="ought_return_qty" :label="$t('getapi[1848]')" align="right">
				<template slot-scope="scope">
					{{scope.row.ought_return_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="return_qty" :label="$t('getapi[1849]')" align="right">
				<template slot-scope="scope">
					{{scope.row.return_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="receive_qty" :label="$t('getapi[1850]')" align="right">
				<template slot-scope="scope">
					{{scope.row.receive_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="check_remark" :label="$t('getapi[1851]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Pur_Reason" :label="$t('getapi[1852]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="transact_person" :label="$t('getapi[1167]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="concedeQty" :label="$t('getapi[1773]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="heat_no" :label="$t('getapi[1765]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="After_In_Return_Qty" :label="$t('getapi[6027]')" align="right">
				<template slot-scope="scope">
					{{scope.row.After_In_Return_Qty | thousandth}}
				</template>
			</el-table-column>
			
			<el-table-column show-overflow-tooltip prop="fa_flag" label="FA"></el-table-column>
			<el-table-column show-overflow-tooltip prop="routing_sequence" :label="$t('getapi[2326]')"></el-table-column>
		</el-table>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="100"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="PurReceiveLineViewInfo" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'purreceivedetailview',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight2
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.authority();
	},
	methods: {
		authority() {
			let that = this;
            that.$refs.SetBtn.SetButtonEnable('');
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'PurReceiveLineViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Sys/Currency/SysSearchBasicList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Pur/Receive/OverViewExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
